import { ArrowUpRight, X } from "lucide-react";
import { ADVERTISEMENT_URL } from "../utils/billing";

export default function UsageLimitModal({ error, onClose, darkMode }) {
  if (!error) return null;

  const panelColors = darkMode
    ? "border-gray-800 bg-[#111827] text-white"
    : "border-slate-200 bg-white text-slate-900";

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <section
        role="dialog"
        aria-modal="true"
        aria-labelledby="usage-limit-title"
        className={`w-full max-w-md rounded-3xl border p-7 shadow-2xl ${panelColors}`}
      >
        <div className="mb-5 flex items-start justify-between">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-amber-500/10 text-amber-400">
            <span className="text-2xl font-bold">!</span>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close usage limit dialog"
            className={`rounded-lg p-2 transition ${darkMode ? "text-gray-400 hover:bg-gray-800 hover:text-white" : "text-slate-500 hover:bg-slate-100 hover:text-slate-900"}`}
          >
            <X size={18} />
          </button>
        </div>
        <h2 id="usage-limit-title" className="text-xl font-bold">
          Feature Limit Reached. Please upgrade your plan.
        </h2>
        <p className={`mt-3 text-sm leading-6 ${darkMode ? "text-gray-400" : "text-slate-600"}`}>
          {error.message || "Your organization has reached the usage limit for this feature."}
        </p>
        {error.feature && (
          <p className={`mt-3 text-xs uppercase tracking-wide ${darkMode ? "text-gray-500" : "text-slate-500"}`}>
            {error.feature.replace(/_/g, " ")}
            {Number.isFinite(error.current_usage) && Number.isFinite(error.limit)
              ? ` · ${error.current_usage} of ${error.limit} used`
              : ""}
          </p>
        )}
        <div className="mt-7 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onClose}
            className={`rounded-xl px-4 py-2.5 text-sm font-semibold transition ${darkMode ? "bg-gray-800 text-gray-200 hover:bg-gray-700" : "bg-slate-100 text-slate-700 hover:bg-slate-200"}`}
          >
            Maybe later
          </button>
          <a
            href={ADVERTISEMENT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 rounded-xl bg-purple-600 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-purple-500"
          >
            Upgrade your plan <ArrowUpRight size={16} />
          </a>
        </div>
      </section>
    </div>
  );
}
